import { isTaskInProgress } from "./NotificationHelpers";

/**
 * Filter notifications based on read/unread status
 */
export const filterNotifications = (allNotifications, showReadNotifications) => {
    return allNotifications.filter((notification) => {
        // In READ mode: NEVER show in-progress tasks (only show completed/failed read items)
        if (showReadNotifications) {
            // Must be read AND not in progress
            return notification.isRead === true && !isTaskInProgress(notification.status);
        }

        // In UNREAD mode: Always show in-progress tasks OR unread notifications
        if (isTaskInProgress(notification.status)) {
            return true;
        }

        // Show unread notifications
        return !notification.isRead;
    });
};